import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "next-draws-view" }

import { ref, onMounted } from 'vue'
import type { UpcomingDraw } from '../types/lottery'
import LuckyNumbersSection from '../components/LuckyNumbersSection.vue'
import { useUpcomingDrawsStore } from '../stores/upcomingDraws'
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'NextDrawsView',
  setup(__props) {

const upcomingDrawsStore = useUpcomingDrawsStore()
const router = useRouter()
const favorites = ref<UpcomingDraw[]>([])

// Load favorites from local storage
const loadFavorites = () => {
  const savedFavorites = localStorage.getItem('favoriteDraws');
  if (savedFavorites) {
    favorites.value = JSON.parse(savedFavorites);
  }
};

// Save favorites to local storage
const saveFavorites = () => {
  localStorage.setItem('favoriteDraws', JSON.stringify(favorites.value));
};

const handleBet = (draw: UpcomingDraw) => {
  if (!draw?.game_slug) return
  router.push(`/lottery/${draw.game_slug}`)
}

const handleFavorite = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return;
  const index = favorites.value.findIndex(fav => fav.id === draw.id);
  if (index === -1) {
    favorites.value.push(draw);
  } else {
    favorites.value.splice(index, 1);
  }
  saveFavorites();
}

const isFavorited = (draw: UpcomingDraw) => {
  if (!draw || typeof draw.id === 'undefined') return false;
  return favorites.value.some(fav => fav.id === draw.id);
};


onMounted(async () => {
  loadFavorites();
  if (!upcomingDrawsStore.draws.length) {
    // Fetch all draws without date filter
    upcomingDrawsStore.fetchDraws(1)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LuckyNumbersSection, {
      title: _ctx.$t('sections.upcomingDraws'),
      description: _ctx.$t('results.description'),
      games: _unref(upcomingDrawsStore).draws,
      isFavorited: isFavorited,
      onBet: handleBet,
      onFavorite: handleFavorite
    }, null, 8, ["title", "description", "games"])
  ]))
}
}

})